import { render, staticRenderFns } from "./ReportUnitCard.vue?vue&type=template&id=38f6b378"
import script from "./ReportUnitCard.vue?vue&type=script&lang=js"
export * from "./ReportUnitCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports